<template>
    <home endpoint="seatzone" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'seatzone',
  components: {
    home,
  },
  data  () {
    return {
      params: {
        fields: [
          {name: 'ZoneCode', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'Description', label: 'Descripción'},
          {name: 'RowFrom', label: 'Fila desde', editor: 'number'},
          {name: 'RowTo', label: 'Fila hasta', editor: 'number'},
          {name: 'ColumnType', label: 'Tipo de columna', editor: 'select', required: true, defValue: 0,
              options: [
                    {value: 0, label: 'Todas'},
                    {value: 1, label: 'Ventana'},
                    {value: 2, label: 'Pasillo'},
                    {value: 3, label: 'Centro'},
                    ]},
          {name: 'ExitRow', label: 'Solo fila de emergencia', editor: 'checkbox'},
          {name: 'FeeCode', relation: 'fee', optionLabels: 'Name',
                editor: 'select', label: 'Cargo', id: 'FeeCode', addBlank: true},
          {name: 'Priority', label: 'Prioridad', editor: 'number', defValue: 0},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'},
          ],
        title: 'Zonas de Asientos',
        title2: 'Zona de Asiento',
        primaryKey: 'ZoneCode',
      }
    }
  },
}
</script>
